<template>
  <v-card
    :loading="loading"
    :disabled="loading"
    elevation="0"
  >
    <v-card-text class="pa-0">
      <div class="text-center">
        <h2>
          {{ $t("pre_regis_complete.list_of_registered_subjects") }}
          <span class="deep-orange--text">
            {{ $t("pre_regis_complete.early") }}
          </span>
        </h2>
        <v-simple-table
          dense
          class="mt-2"
        >
          <template v-slot:default>
            <thead>
              <!-- --------------------------------------------------------------- -->
              <!-- Table Header -->
              <tr>
                <th
                  class="text-center"
                  style="min-width:120px"
                >
                  {{ $t("pre_regis_add_subject.subject_id") }}
                </th>
                <th
                  class="text-center"
                  style="min-width:150px"
                >
                  {{ $t("pre_regis_add_subject.subject_name") }}
                </th>
                <th class="text-center">
                  {{ $t("pre_regis_add_subject.credit") }}
                </th>
                <th
                  class="text-center"
                  style="min-width:80px; width:80px;"
                >
                  {{ $t("pre_regis_add_subject.section") }}
                </th>
                <!-- <th class="text-center">
                  {{ $t("pre_regis_add_subject.type") }}
                </th> -->
                <th class="text-center">
                  {{ $t("pre_regis_add_subject.class_exam_timetable") }}
                </th>
                <th class="text-center">
                  {{ $t("pre_regis_add_subject.limit") }}
                </th>
                <th class="text-center last-cell">
                  {{ $t("pre_regis_add_subject.number_of_people_registered") }}
                </th>
                <th class="text-center last-cell">
                  {{ $t("pre_regis_add_subject.result") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <!-- --------------------------------------------------------------- -->
              <!-- Table Display registered -->
              <tr
                v-for="item in computed_registering_subject_list"
                :key="item.name"
              >
                <td :class="get_class(item)">
                  <span v-if="!(item.has_pair && item.lect_or_prac === 'ป')">{{
                    item.subject_id
                  }}</span>
                </td>
                <td :class="get_class(item)">
                  <a
                    v-if="!(item.has_pair && item.lect_or_prac === 'ป')"
                    class="subject-link"
                    @click="openSubjectDialog(item.subject_id)"
                  >
                    {{ item.subject_ename }}
                  </a>
                </td>
                <td :class="get_class(item)">
                  <span v-if="!(item.has_pair && item.lect_or_prac === 'ป')">
                    <class-hour-text :item="item"></class-hour-text>
                  </span>
                </td>
                <td class="full-width text-right">
                  {{ item.section }}
                  <lect-or-prac-chip :item="item"></lect-or-prac-chip>
                  {{
                    item.has_same_section ? " (" + item.curr2_tname + ")" : ""
                  }}
                </td>
                <!-- <td>Cr</td> -->
                <td class="full-width">
                  <teach-and-exam-time :item="item"></teach-and-exam-time>
                </td>
                <td>{{ item.PRE_LIMIT != "0" ? item.PRE_LIMIT : "-" }}</td>
                <td>{{ item.PRE_COUNT }}</td>
                <td class="last-cell full-width">
                  <span v-if="item.grade === ''">{{
                    $t("pre_regis_add_subject.waiting")
                  }}</span>
                  <span
                    v-if="item.grade === 'Y'"
                    class="green--text"
                  >
                    {{ $t("pre_regis_complete.can_register") }}
                  </span>
                  <span v-if="item.grade === 'N'">
                    <span
                      v-if="item.queue_list_status && item.queue_list_status === '9'"
                      class="red--text"
                    >
                      {{ $t("pre_regis_complete.can_not_register_violate_condition") }}
                    </span>
                    <span
                      v-else
                      class="red--text"
                    >
                      {{ $t("pre_regis_complete.can_not_register") }}
                    </span>
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <subject-dialog ref="subject_dialog" />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { parseDate_Time } from "@/helper/registration";
import ClassHourText from "./ClassHourText.vue";
import TeachAndExamTime from "./TeachAndExamTime.vue";
import RegistrationProvider from "@/services/registration.provider.js";
import LectOrPracChip from "./LectOrPracChip.vue";
import SubjectDialog from "@/views/teach_table/components/SubjectDialog.vue";

const RegistrationService = new RegistrationProvider();
export default {
  name: "PreRegisComplete",
  components: {
    ClassHourText,
    TeachAndExamTime,
    LectOrPracChip,
    SubjectDialog,
  },
  props: {
    clickNext: {
      type: Function,
    },
    year: {
      type: String,
    },
    semester: {
      type: String,
    },
    student_id: {
      type: String,
    },
  },
  data: () => ({
    loading: false,
    registering_subject_list: [],
  }),
  computed: {
    // จะแปลงพวกวันเรียน วันสอบ ให้อยู่ในตัวแปรที่เหมาะสมต่อการแสดง
    computed_registering_subject_list() {
      const temp = this.registering_subject_list.map((item) => {
        const same_subject = this.registering_subject_list.filter(
          (item_2) => item_2.subject_id === item.subject_id
        );
        if (same_subject.length > 1) {
          return { ...item, has_pair: true };
        } else return { ...item, has_pair: false };
      });
      return temp
        .map((item) => parseDate_Time(item))
        .sort((a, b) => {
          if (a.subject_id > b.subject_id) return 1;
          if (a.subject_id < b.subject_id) return -1;
          if (a.subject_id == b.subject_id) {
            if (a.lect_or_prac === "ป") return 1;
            return -1;
          }
          return 0;
        });
    },
  },
  methods: {
    openSubjectDialog(subjectId) {
      if (this.$refs.subject_dialog) {
        this.$refs.subject_dialog.show_item_detail(subjectId);
      }
    },
    get_class(item) {
      if (item.has_pair && item.lect_or_prac === "ท") return "no_bottom_line ";
      if (item.has_pair && item.lect_or_prac === "ป") return "no_top_line ";
      return "";
    },
    async getPreRegisResult() {
      try {
        this.loading = true;
        const data = await RegistrationService.getPreRegisResult({
          student_id: this.student_id,
          year: this.year,
          semester: this.semester,
          level_id: "1",
        });
        this.registering_subject_list = data;
        this.loading = false;
      } catch (error) {
        this.$toasted.error(JSON.stringify(error.response.data.message), { duration: 0 });
        this.loading = false;
      }
    },
  },
  created() {
    this.getPreRegisResult();
  },
};
</script>

<style lang="scss" scoped>
td {
  border-width: 0px;
  border-left-width: 1px;
  border-bottom-width: 1px;
  border-style: solid;
  border-color: #ccc;
}
.last-cell {
  border-right-width: 1px;
}
thead {
  background-color: #ffbd43;
}

th {
  padding: 0;
  overflow: hidden;
  white-space: nowrap;
}

.full-width {
  overflow: hidden;
  white-space: nowrap;
}

.no_bottom_line {
  border-bottom-width: 0px !important;
}
.no_top_line {
  border-top-width: 0px !important;
}

.subject-link {
  color: #1976d2;
  cursor: pointer;
  text-decoration: none;
  font-weight: inherit;
}

.subject-link:hover {
  text-decoration: none;
}
</style>
